var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlertNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 23.5,
    r: 23.5,
    fill: "#EE3300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 35.25C23.8125 35.25 23.224 35.0052 22.7344 34.5156C22.2448 34.026 22 33.4375 22 32.75C22 32.0625 22.2448 31.474 22.7344 30.9844C23.224 30.4948 23.8125 30.25 24.5 30.25C25.1875 30.25 25.776 30.4948 26.2656 30.9844C26.7552 31.474 27 32.0625 27 32.75C27 33.4375 26.7552 34.026 26.2656 34.5156C25.776 35.0052 25.1875 35.25 24.5 35.25ZM22 27.75V12.75H27V27.75H22Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertNotification);
export default __webpack_public_path__ + "static/media/alert_notification.0380a4b7e2f6994f7169d82a61fb6004.svg";
export { ForwardRef as ReactComponent };